import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header-cell__content"
}
const _hoisted_2 = { class: "header-cell__content--text" }

import { TableHeaderFontSize } from '@/corePagesModule/BaseTableContent/interface/tableContentHeaders';
import { i18n } from '@/i18n';
import { computed, ref } from 'vue';

type BackgroundColor = 'bg-default' | 'bg-secondary';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'TableHead',
  props: {
    label: { default: '' },
    textAlign: { default: 'center' },
    fontSize: { default: 'fontSizeS' },
    backgroundColor: { default: 'bg-secondary' }
  },
  emits: ["onHover", "onLeave", "onClick"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "dfc9b2b2": (textAlign.value)
}))

const props = __props;

//text-align
const textAlign = ref(props.textAlign);

//fontSizeの切り替え
const fontSizeClass = computed(() => {
  return props.fontSize;
});

//fontSizeの切り替え
const bgColorClass = computed(() => {
  return props.backgroundColor;
});

// emits
const emits = __emit;

//変数
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("th", {
    class: _normalizeClass([[fontSizeClass.value, bgColorClass.value], "header-cell"]),
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => (emits('onHover'))),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (emits('onLeave'))),
    onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('onClick')))
  }, [
    (props.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(props.label)), 1),
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 34))
}
}

})